import React from 'react';
import { NavLink } from 'react-router-dom';
import useUserSession from '../useUserSession'; // Import du hook personnalisé
import { FaSearch } from "react-icons/fa";

function Navigation() {
  const { logout } = useUserSession(); // Utilisation du hook
  return (
    <nav className="navbar navbar-dark align-items-start sidebar sidebar-dark accordion bg-gradient-primary p-0">
      <div className="container-fluid d-flex flex-column p-0">
        <NavLink className="navbar-brand d-flex justify-content-center align-items-center sidebar-brand m-0" to="/">
          <div className="sidebar-brand-icon rotate-n-15">
            <img src="assets/img/dogs/groupinLogo.svg" style={{ height: '44px' }} alt="Logo" />
          </div>
          <div className="sidebar-brand-text mx-3">
            <span>ADMIN</span>
          </div>
        </NavLink>
        <hr className="sidebar-divider my-0" />
        <ul className="navbar-nav text-light" id="accordionSidebar">
          <li className="nav-item">
            <NavLink className="nav-link" to="/">
              <i className="fas fa-tachometer-alt"></i>
              <span>Dashboard</span>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/admin">
              <i className="fas fa-user-shield"></i>
              <span>Admins</span>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/user">
              <i className="fas fa-users"></i>
              <span>Utilisateurs</span>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/annonce">
              <i className="fas fa-bullhorn"></i>
              <span>Annonces</span>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/recherche">
              <FaSearch style={{marginRight:'5px'}}/>
              <span>Recherches</span>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/newsletter">
              <i className="fas fa-envelope"></i>
              <span>Newsletter</span>
            </NavLink>
          </li>
          <li className="nav-item">
            <span className="nav-link" onClick={logout} style={{cursor : 'pointer'}}>
              <i className="fas fa-power-off"></i>
              <span>Se déconnecter</span>
            </span>
          </li>
        </ul>
        <div className="text-center d-none d-md-inline">
          <button className="btn rounded-circle border-0" id="sidebarToggle" type="button"></button>
        </div>
      </div>
    </nav>
  );
}

export default Navigation;